import { Settings } from 'luxon'
import { PreferredLanguage } from '../src/models/User/PreferredLanguage'

Settings.defaultZone = 'Europe/Oslo'
Settings.defaultLocale = PreferredLanguage.Bokmal // will be overwritten by userPreferredLanguage when user is loaded, but we set it here in order to have a sensible default
